import { createStrictContext as t } from "../../temp-lib/util/context/createStrictContext.js";
import { useRef as n } from "react";
import { jsx as i } from "react/jsx-runtime";
const [c, a] = t("RoninNameService"), u = (e) => {
  const {
    children: r
  } = e, o = n(null);
  return /* @__PURE__ */ i(c, {
    value: {
      rns: o
    },
    children: r
  });
};
export {
  u as RoninNameServiceProvider,
  a as useRoninNameServiceContext
};
//# sourceMappingURL=RoninNameServiceContext.js.map
